module.exports = __webpack_public_path__ + "img/writingSeminar_041022_A.a15d669a.jpg";